<template>
  <div>
    <div class="ibox">
      <div class="ibox-title">
        <h5>Pbns</h5>
        <div class="ibox-tools pull-right">
          <a class="collapse-link">
            <i class="fa fa-chevron-up"></i>
          </a>
        </div>
      </div>
      <div class="ibox-content">
        <table class="table table-hover" id="dt">
          <thead>
          <tr>
            <th>Network</th>
            <th>Type</th>
            <th>Domains</th>
            <th>Built</th>
            <th>Issues</th>
            <th>Linked</th>
            <th>No Link</th>
            <th>Pipeline</th>
          </tr>
          </thead>
          <tbody>
<!--          <tr v-for="(line, i) in report" :key="'report-' + i">-->
<!--            <td>{{ line.client ? line.client.name : '/' }}</td>-->
<!--            <td>{{ line.type || '/' }}</td>-->
<!--            <td>{{ line.domains }}</td>-->
<!--            <td>{{ line.built }}</td>-->
<!--            <td>0</td>-->
<!--            <td>{{ line.linked }}</td>-->
<!--            <td>{{ line['no-links'] }}</td>-->
<!--            <td>{{ line.pipeline }}</td>-->
<!--          </tr>-->
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { Query } from '../../../../../mixins/helperMixin'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      report: [],
      dt: null
    }
  },
  mixins: [Query],
  mounted () {
    this.getReport()
  },
  computed: {
    ...mapGetters({
      filters: 'getViewFilters'
    })
  },
  watch: {
    filters () {
      this.getReport()
    }
  },
  methods: {
    getReport () {
      axios.get('/pbn/reports/overview?' + this.buildQuery(this.filters))
        .then(r => {
          this.report = r.data.data.overview
          this.dt = $('#dt').DataTable()
          this.dt.rows().remove()
          r.data.data.overview.forEach(row => {
            this.dt.row.add([
              row.client.name,
              row.type,
              row.domains,
              row.built,
              0,
              row.linked,
              row['no-links'],
              row.pipeline
            ])
          })
          this.dt.draw(true)
        }).catch()
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Dashboard/Overview/Pbn.vue